import React, { useEffect } from "react";
import { connect } from "react-redux";
import LeaveCard from "views/console/team-managements/components/LeaveCard";
import HeaderComponent from "components/card/HeaderComponent";
import { Calendar } from "lucide-react";
import {
	getLeaveApprovedList
} from "../../../../redux/overview/overviewState";

const UpcomingLeavesTable = ({
	recordList,
	getList
}) => {

	useEffect(() => {
		getList();
	}, [getList]);
	
	return (
		<HeaderComponent
			title="Upcoming Leaves"
			description="Approved leave requests for the next 30 days"
			icon={<Calendar size={20}/>}
			colorTheme="flat-blue"
			bgcolor="bg-slate-50/50"
			shadow="shadow-sm"
			border="border-b"
		>
			<div className="pt-10 flex-1">
				<div className= "relative pr-1 h-[500px] overflow-y-auto">
					<div className="space-y-3">
						{recordList?.data?.map((item) => (
							<LeaveCard
								key={item?.lve_id} 
								{...item}
							/>
						))}
					</div>
				</div>
			</div>
		</HeaderComponent>
		
	);
};

const mapStateToProps = (state) => ({
	recordList: state.overview.teamLeaveApprovedList?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getList: (filters) => dispatch(getLeaveApprovedList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpcomingLeavesTable);
